export const categories = [
  { slug: 'all', name: '全部', description: '浏览所有漫画作品' },
  { slug: 'japanese', name: '日本h漫画', description: '精选日本成人漫画作品' },
  { slug: 'romance', name: '恋爱', description: '浪漫爱情题材漫画' },
  { slug: 'drama', name: '剧情', description: '深度剧情类漫画作品' },
  { slug: 'fantasy', name: '奇幻', description: '奇幻世界冒险漫画' },
  { slug: 'school', name: '校园', description: '校园青春题材漫画' },
  { slug: 'office', name: '职场', description: '职场生活题材漫画' },
  { slug: 'action', name: '动作', description: '热血动作类漫画' },
];

export const mangaList = [
  {
    id: '1',
    title: '禁忌之恋 ~ 无法言说的秘密',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20style%20cover%20art%20of%20a%20romantic%20couple%20in%20soft%20warm%20lighting%2C%20elegant%20composition%2C%20dark%20background%20with%20red%20accents%2C%20mature%20aesthetic%2C%20clean%20illustration%20style%20with%20delicate%20linework%20and%20warm%20tone&width=400&height=560&seq=manga-cover-01&orientation=portrait',
    author: '山田花子',
    category: 'romance',
    tags: ['恋爱', '禁忌', '成人'],
    description: '一段无法被世俗接受的爱情，两个人在命运的安排下相遇，却面临重重阻碍。他们能否突破禁忌，找到属于自己的幸福？本作以细腻的笔触描绘了成年人之间复杂而深刻的情感纠葛。',
    updateDate: '2026-08-06',
    views: 185230,
    rating: 4.8,
    featured: true,
  },
  {
    id: '2',
    title: '办公室的秘密 ~ 午夜加班',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20style%20cover%20art%20of%20office%20workers%20in%20modern%20city%20night%20scene%2C%20warm%20ambient%20light%2C%20dark%20moody%20background%2C%20mature%20illustration%20style%20with%20clean%20lines%20and%20soft%20shadows&width=400&height=560&seq=manga-cover-02&orientation=portrait',
    author: '田中一郎',
    category: 'office',
    tags: ['职场', '恋爱', '成人'],
    description: '在繁忙的都市写字楼里，两个同事因为一次意外的加班而逐渐走近。午夜的办公室里，隐藏着不为人知的秘密与心动。职场恋爱故事，真实而动人。',
    updateDate: '2026-08-05',
    views: 142560,
    rating: 4.6,
    featured: true,
  },
  {
    id: '3',
    title: '校园往事 ~ 那年初夏',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20style%20cover%20art%20of%20school%20uniform%20characters%20under%20cherry%20blossoms%2C%20warm%20golden%20sunlight%2C%20nostalgic%20atmosphere%2C%20clean%20illustration%20style%20with%20delicate%20linework&width=400&height=560&seq=manga-cover-03&orientation=portrait',
    author: '佐藤美咲',
    category: 'school',
    tags: ['校园', '青春', '恋爱'],
    description: '高中三年，是人生中最美好的时光。他和她在樱花树下许下的约定，多年后是否还能兑现？一部关于青春、成长与初恋的温暖故事。',
    updateDate: '2026-08-04',
    views: 98540,
    rating: 4.5,
    featured: false,
  },
  {
    id: '4',
    title: '异世界冒险 ~ 龙与公主',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20style%20cover%20art%20of%20fantasy%20warrior%20and%20princess%20in%20medieval%20castle%2C%20dramatic%20lighting%2C%20dark%20epic%20background%20with%20gold%20accents%2C%20clean%20illustration%20style&width=400&height=560&seq=manga-cover-04&orientation=portrait',
    author: '高桥龙之介',
    category: 'fantasy',
    tags: ['奇幻', '冒险', '恋爱'],
    description: '普通上班族意外穿越到异世界，成为传说中的勇者。在这个充满魔法与剑的世界里，他与美丽的公主展开了一段惊心动魄的冒险之旅。',
    updateDate: '2026-08-03',
    views: 210300,
    rating: 4.7,
    featured: true,
  },
  {
    id: '5',
    title: '邻家姐姐 ~ 温柔陷阱',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20style%20cover%20art%20of%20elegant%20woman%20in%20modern%20apartment%20setting%2C%20warm%20indoor%20lighting%2C%20intimate%20atmosphere%2C%20dark%20cozy%20background%2C%20clean%20illustration%20style&width=400&height=560&seq=manga-cover-05&orientation=portrait',
    author: '铃木优子',
    category: 'romance',
    tags: ['恋爱', '日常', '成人'],
    description: '搬来新公寓后，他发现隔壁住着一位温柔美丽的姐姐。随着日常的接触增多，两人之间的关系渐渐超越了普通的邻里之情。',
    updateDate: '2026-08-02',
    views: 167890,
    rating: 4.6,
    featured: false,
  },
  {
    id: '6',
    title: '黑道之恋 ~ 危险的温柔',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20style%20cover%20art%20of%20dangerous%20romance%20in%20urban%20night%20street%2C%20dramatic%20red%20and%20black%20color%20palette%2C%20dark%20moody%20background%2C%20clean%20illustration%20style&width=400&height=560&seq=manga-cover-06&orientation=portrait',
    author: '黑崎健',
    category: 'drama',
    tags: ['剧情', '恋爱', '成人'],
    description: '她是普通的大学生，他是黑道组织的继承人。一次偶然的相遇让两个世界的人走到了一起，这段感情注定充满危机与挑战。',
    updateDate: '2026-08-01',
    views: 231450,
    rating: 4.9,
    featured: true,
  },
  {
    id: '7',
    title: '新婚生活 ~ 甜蜜的日常',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20style%20cover%20art%20of%20newlywed%20couple%20in%20cozy%20home%20morning%20scene%2C%20soft%20warm%20sunlight%2C%20romantic%20atmosphere%2C%20dark%20background%20with%20warm%20accents%2C%20clean%20illustration&width=400&height=560&seq=manga-cover-07&orientation=portrait',
    author: '山田花子',
    category: 'romance',
    tags: ['恋爱', '日常', '成人'],
    description: '新婚夫妇的甜蜜日常，从早晨的第一杯咖啡到夜晚的依偎入眠。每一页都充满了温馨与浪漫，让人忍不住嘴角上扬。',
    updateDate: '2026-07-31',
    views: 128760,
    rating: 4.4,
    featured: false,
  },
  {
    id: '8',
    title: '忍者物语 ~ 暗夜之花',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20style%20cover%20art%20of%20female%20ninja%20in%20moonlit%20forest%2C%20dramatic%20shadow%20play%2C%20dark%20mysterious%20background%2C%20traditional%20Japanese%20aesthetic%2C%20clean%20illustration&width=400&height=560&seq=manga-cover-08&orientation=portrait',
    author: '伊藤忍',
    category: 'action',
    tags: ['动作', '剧情', '成人'],
    description: '战国时代的日本，一位女忍者在暗夜中执行危险的任务。然而，当她遇到敌方的武士首领后，一切都发生了改变。',
    updateDate: '2026-07-30',
    views: 198320,
    rating: 4.7,
    featured: true,
  },
  {
    id: '9',
    title: '医院夜话 ~ 深夜值班室',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20style%20cover%20art%20of%20medical%20professionals%20in%20hospital%20corridor%20at%20night%2C%20soft%20dim%20lighting%2C%20dark%20atmosphere%2C%20clean%20illustration%20style&width=400&height=560&seq=manga-cover-09&orientation=portrait',
    author: '中村良子',
    category: 'drama',
    tags: ['剧情', '恋爱', '职场'],
    description: '深夜的医院走廊，值班医生与护士之间悄然萌芽的感情。在生死交织的医院里，他们找到了彼此的温暖。',
    updateDate: '2026-07-29',
    views: 115670,
    rating: 4.5,
    featured: false,
  },
  {
    id: '10',
    title: '温泉旅馆 ~ 雪国之恋',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20style%20cover%20art%20of%20couple%20in%20traditional%20hot%20spring%20inn%20with%20snowy%20landscape%2C%20warm%20steam%20atmosphere%2C%20dark%20background%20with%20warm%20light%2C%20clean%20illustration&width=400&height=560&seq=manga-cover-10&orientation=portrait',
    author: '渡边和子',
    category: 'romance',
    tags: ['恋爱', '旅行', '成人'],
    description: '为了治愈情伤而独自前往温泉旅馆的都市女性，在那里邂逅了一位神秘的男子。雪国之中，两颗受伤的心逐渐靠近。',
    updateDate: '2026-07-28',
    views: 145890,
    rating: 4.6,
    featured: false,
  },
  {
    id: '11',
    title: '咖啡店的她 ~ 午后时光',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20style%20cover%20art%20of%20barista%20and%20customer%20in%20cozy%20cafe%20afternoon%2C%20warm%20sunlight%20through%20windows%2C%20dark%20cozy%20background%2C%20clean%20illustration&width=400&height=560&seq=manga-cover-11&orientation=portrait',
    author: '小林薰',
    category: 'romance',
    tags: ['恋爱', '日常', '美食'],
    description: '每天下午三点，他都会准时来到这家街角的咖啡店。吸引他的不仅是香醇的咖啡，更是那位笑容温暖的女咖啡师。',
    updateDate: '2026-07-27',
    views: 93670,
    rating: 4.3,
    featured: false,
  },
  {
    id: '12',
    title: '魔法学院 ~ 禁忌之书',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20style%20cover%20art%20of%20magic%20academy%20students%20in%20ancient%20library%2C%20mystical%20glowing%20atmosphere%2C%20dark%20magical%20background%2C%20clean%20illustration%20style&width=400&height=560&seq=manga-cover-12&orientation=portrait',
    author: '藤原魔法',
    category: 'fantasy',
    tags: ['奇幻', '校园', '冒险'],
    description: '在精英魔法学院中，一本被封印的禁忌之书意外被打开。两位年轻魔法师因此卷入了一场关乎世界命运的冒险。',
    updateDate: '2026-07-26',
    views: 176540,
    rating: 4.8,
    featured: false,
  },
];

export const faqList = [
  {
    question: 'h漫画平台是否免费？',
    answer: 'h漫画平台提供大量免费漫画内容供读者阅读。部分精选作品可能需要会员权限，我们会不定期推出免费阅读活动，让更多读者享受优质漫画内容。',
  },
  {
    question: '如何保障用户的阅读隐私？',
    answer: '我们非常重视用户的隐私保护。平台采用先进的加密技术，确保您的阅读记录和个人信息得到充分保护。您可以在设置中随时管理隐私选项。',
  },
  {
    question: 'h漫画的更新频率是怎样的？',
    answer: '我们每日更新最新漫画内容，确保读者能够第一时间阅读到最新的漫画章节。热门作品的更新频率通常为每周2-3次。',
  },
  {
    question: '支持哪些设备阅读？',
    answer: 'h漫画支持PC端、平板和手机端阅读，适配各种主流浏览器。您可以在任何设备上享受流畅的阅读体验，阅读进度会自动同步。',
  },
  {
    question: '如何搜索想看的漫画？',
    answer: '您可以通过首页的搜索栏输入关键词搜索，也可以浏览分类页面按题材筛选。我们支持按作品名、作者名和标签进行搜索。',
  },
];

export const testimonials = [
  {
    name: '王先生',
    role: '资深读者',
    content: 'h漫画是我用过最好的漫画平台，资源丰富，更新速度快，阅读体验非常流畅。推荐给了很多朋友。',
    rating: 5,
  },
  {
    name: '李女士',
    role: '漫画爱好者',
    content: '分类很清晰，可以根据自己喜欢的题材快速找到想要的漫画。画面质量很高，加载速度也很快。',
    rating: 5,
  },
  {
    name: '张先生',
    role: '长期用户',
    content: '使用h漫画已经两年了，每天都会上来看看有没有更新。平台越来越完善，客服响应也很及时。',
    rating: 4,
  },
  {
    name: '赵女士',
    role: '新用户',
    content: '朋友推荐过来的，第一次用就被丰富的漫画库惊艳到了。界面简洁，操作方便，很喜欢。',
    rating: 5,
  },
];

export const siteInfo = {
  name: 'h漫画',
  description: 'h漫画是面向成熟读者的在线漫画阅读平台，汇聚海量精选漫画资源，涵盖多种风格与题材。我们致力于为读者提供高清流畅的阅读体验，每日更新最新漫画内容，满足不同读者的阅读偏好。',
  founded: '2020年',
  totalManga: '10,000+',
  dailyUsers: '500,000+',
  totalViews: '1亿+',
  email: 'contact@hmanga.com',
  phone: '400-888-8888',
  address: '中国上海市浦东新区动漫产业园区',
};